import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { GoogleService } from '../services/auth/google/google.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css'],
})
export class SignUpComponent {
  showPassword = false;
  showConfirmPassword = false;
  submitted = false;

  googleIcon = './assets/' + environment.projectName + '/icons/google.svg';
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';
  returnUrl: string = '/';
  user: any = { name: '', phone: '', sub: '' }; 
  confirmPassword: string = '';

  constructor(
    private google: GoogleService,
    private authService: AuthService,
    private userInfoService: UserInfoService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.params.subscribe((params) => {
      if (params) this.lang = params['lang'];
    });

    this.route.queryParams.subscribe((params) => {
      this.returnUrl = params['returnUrl'] || `/${this.lang}/home`;
    });
  }

  get nameError(): string {
    if (!this.submitted) return '';
    if (!this.user.name?.trim()) return 'الاسم الكامل مطلوب';
    if (this.user.name.trim().length < 3) return 'الاسم يجب أن يكون 3 أحرف على الأقل';
    return '';
  }

  get phoneError(): string {
    if (!this.submitted) return '';
    if (!this.user.phone?.trim()) return 'رقم الهاتف مطلوب';
    if (!/^[0-9]{10,15}$/.test(this.user.phone.trim())) return 'رقم الهاتف غير صحيح';
    return '';
  }

  get passwordError(): string {
    if (!this.submitted) return '';
    if (!this.user.sub) return 'كلمة المرور مطلوبة';
    if (this.user.sub.length < 8) return 'كلمة المرور يجب أن تكون 8 أحرف على الأقل';
    return '';
  }

  get confirmPasswordError(): string {
    if (!this.submitted) return '';
    if (!this.confirmPassword) return 'تأكيد كلمة المرور مطلوب';
    if (this.confirmPassword !== this.user.sub) return 'كلمة المرور وتأكيدها غير متطابقين';
    return '';
  }

  get isFormValid(): boolean {
    return (
      !this.nameError &&
      !this.phoneError &&
      !this.passwordError &&
      !this.confirmPasswordError &&
      !!this.user.name?.trim() &&
      !!this.user.phone?.trim() &&
      !!this.user.sub &&
      !!this.confirmPassword
    );
  }

  toggleShowPassword() { this.showPassword = !this.showPassword; }
  toggleConfirmShowPassword() { this.showConfirmPassword = !this.showConfirmPassword; }

  signUp() {
    this.submitted = true;
    if (!this.isFormValid) return;

    this.authService.registerUser(this.user).subscribe({
      next: (response: any) => {
        this.userInfoService.setUserInfo(response);
        this.router.navigateByUrl(this.returnUrl);
      },
      error: (err) => {
        const errorMessage = err?.error?.message || 'يوجد خطأ في إنشاء الحساب، تأكد أن رقم الهاتف غير مسجل من قبل';
        Swal.fire({
          icon: 'error',
          title: 'خطأ في إنشاء الحساب',
          text: errorMessage,
          confirmButtonText: 'حسناً',
          confirmButtonColor: '#d33',
          customClass: { popup: 'swal-rtl' },
        });
      },
    });
  }

  registerWithGoogle() { this.google.login(); }
}